import { render, staticRenderFns } from "./UpdateDetail.vue?vue&type=template&id=6dc6148f&scoped=true"
import script from "./UpdateDetail.vue?vue&type=script&lang=js"
export * from "./UpdateDetail.vue?vue&type=script&lang=js"
import style0 from "./UpdateDetail.vue?vue&type=style&index=0&id=6dc6148f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc6148f",
  null
  
)

export default component.exports